import { MergeDataConfig, MergeWith } from 'ihub/common';
import { AdvancedTourStep } from '../shared-types';
import { TaskTourProps } from './task-tour-props';

export function getMergeDataTourSteps({
	defaultStyles,
	microTaskConfigType,
}: Readonly<TaskTourProps>): AdvancedTourStep[] {
	if (!microTaskConfigType) return [];
	const config = microTaskConfigType as MergeDataConfig;

	const collection1Field = {
		id: 'collection1',
		selector: '[data-tour="collection1"]',
		content:
			'Required: When Use Expression Collection for Collection 1 is set to false, this is used to choose a value from the input. When set to true, this is used to choose an expression instead.',
	};

	const mergeFields = [
		{
			id: 'merge-into',
			selector: '[data-tour="merge-into"]',
			content:
				'Required: This is used to choose between merging data into the record data or the context data.',
		},
		{
			id: 'merge-path',
			selector: '[data-tour="merge-path"]',
			content:
				'Required: This is used to set the key for the key value to be added to each record.',
		},
	];

	return [
		{
			id: 'merge-with',
			selector: '[data-tour="merge-with"]',
			content:
				'Required: This is used to choose whether to Merge With All Records or Merge per record. ',
		},
		...(config.mergeWith === MergeWith.MergePerRecord
			? [
					{
						id: 'expression-collection-1',
						selector: '[data-tour="expression-collection-1"]',
						content:
							'This is used to determine whether or not to use an expression for the first value or to choose an option from the input.',
					},
					collection1Field,
					{
						id: 'expression-collection-2',
						selector: '[data-tour="expression-collection-2"]',
						content:
							'This is used to determine whether or not to use an expression for the second value or to choose an option from the input.',
					},
					{
						id: 'collection2',
						selector: '[data-tour="collection2"]',
						content:
							'Required: When Use Expression Collection for Collection 2 is set to false, this is used to choose a value from the input. When set to true, this is used to choose an expression instead.',
					},
					...mergeFields,
				]
			: [collection1Field, ...mergeFields]),
	].map(tourItem => ({ ...tourItem, styles: defaultStyles }));
}
